<!-- 地址选择组件 -->
<template>
  <div class="address-add">
    <vanPopup
      v-model="showAddressPopup"
      position="bottom"
      :round="true"
      :lock-scroll="false"
      @click-overlay="closePopup"
      v-backFn="{ show: showAddressPopup, closeFn: 'closePopup' }"
    >
      <div class="popup-wrap">
        <div class="popup-head">
          <div class="popup-title os-font-16-500">{{ popupTitle }}</div>
          <div class="popup-close" @click="closePopup"></div>
        </div>
        <div class="popup-content">
          <div class="address-list">
            <div :class="['address-list-item os-font-14-400', { isError: nameError }]">
              <div class="item-title os-font-15-400">姓名</div>
              <div class="input-container">
                <input
                  ref="receiverName"
                  v-model="addressAddInfo.receiverName"
                  maxlength="20"
                  placeholder="请填写姓名"
                  type="text"
                />
              </div>
            </div>
            <div
              ref="mobilePhoneWrap"
              :class="[
                'address-list-item item-space os-font-14-400',
                { isFocus: isFocus, isError: phoneError }
              ]"
            >
              <div class="item-title os-font-15-400">手机号码</div>
              <div class="input-container">
                <input
                  ref="mobilePhone"
                  v-model="addressAddInfo.mobilePhone"
                  maxlength="20"
                  placeholder="请填写手机号码"
                  type="tel"
                />
              </div>
            </div>
            <div
              :class="[
                'address-list-item area-icon item-space os-font-14-400',
                { isError: areaError }
              ]"
            >
              <div class="item-title os-font-15-400">所在地区</div>
              <div class="input-container">
                <input
                  ref="areaContainer"
                  v-model="area"
                  @click="selectArea"
                  readonly
                  placeholder="省市区县、乡镇等"
                  type="text"
                />
              </div>
              <div class="location-detail" @click.stop="goLocation"></div>
            </div>
            <div
              :class="[
                'address-list-item item-space os-font-14-400',
                { isError: detailAddressError }
              ]"
            >
              <div class="item-title os-font-15-400">详细地区</div>
              <div class="input-container">
                <input
                  ref="detailAddress"
                  v-model="addressAddInfo.detailAddress"
                  maxlength="50"
                  rows="1"
                  autosize
                  placeholder="街道、楼牌号"
                  type="textarea"
                />
              </div>
            </div>
            <div class="address-list-copy item-space-new os-font-14-400">
              <textarea
                oninput="this.style.height = '';this.style.height = this.scrollHeight + 'px'"
                v-model="clipboardText"
                ref="clipboardAddress"
                @focus="clipboardBtnShow = true"
                @blur="clipBlur"
                placeholder="粘贴姓名、手机号、地址，可快速识别您的地址"
              />
              <!-- 粘贴板有值且输入框聚焦 -->
              <div
                ref="clipboardActionRef"
                class="clipboard-actions os-font-12-400"
                v-if="clipboardText"
              >
                <span class="clear" @click="resetAddress">清空</span>
                <span class="identify" @click="clipboardIdentify">识别</span>
              </div>
            </div>
            <div
              class="checkbox os-font-15-500"
              @click="addressAddInfo.isDefault = !addressAddInfo.isDefault"
            >
              <div :class="['unchecked-box', { 'checked-box': addressAddInfo.isDefault }]">
                设为默认地址
              </div>
            </div>
          </div>
        </div>
        <div class="popup-bottom" @click="selectConfirm">
          <div class="popup-button">{{ footerText }}</div>
        </div>
      </div>
    </vanPopup>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import { addAddress, updateAddress } from '../../../api.js'
import { cleanAddress } from 'utils/common'
import { isPhone } from 'utils/reg'
import AddressParse from 'address-parse'
import toast from '@/utils/toast'

export default {
  name: 'addressAdd',
  props: {
    title: {
      type: String,
      default: '新建收件地址'
    },
    // 底部按钮文案
    footerText: {
      type: String,
      default: '保存并使用'
    },
    repairAddressList: {
      type: Array,
      default: () => []
    },
    selectedAddress: {
      type: Object,
      default: () => {}
    },
    isPickUp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showAddressPopup: false,
      currentIndex: 0,
      value: '',
      clipboardText: '',
      clipboardBtnShow: false,
      isFocus: false,
      phoneError: false,
      nameError: false,
      areaError: false,
      detailAddressError: false
    }
  },
  computed: {
    ...mapState('repair', ['addressAddInfo', 'isAddressEdit', 'addressSelectType']),
    area() {
      if (!this.addressAddInfo.area) return ''
      return (
        this.addressAddInfo.province +
        ' ' +
        this.addressAddInfo.city +
        ' ' +
        this.addressAddInfo.area
      )
    },
    popupTitle() {
      return this.isAddressEdit ? '编辑地址' : '新建地址'
    }
  },
  methods: {
    ...mapMutations('repair', ['setPickupAddress', 'setAddressAddALLInfo', 'SET_PICKER_ADDRESS']),
    // 阻止页面滑动
    preventPageScroll() {
      if (this.isPrevent || document.body.classList.contains('isPrevent')) {
        return
      }

      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.marginTop = document.body.style.marginTop
      this.height = document.body.style.height
      this.overflow = document.body.style.overflow
      Object.assign(document.body.style, {
        marginTop: -this.scrollTop + 'px',
        height: window.innerHeight + this.scrollTop + 'px',
        overflow: 'hidden'
      })
      document.body.classList.add('isPrevent')
      this.isPrevent = true
    },
    // 恢复页面滑动
    restorePageScroll() {
      if (!this.isPrevent) {
        return
      }

      Object.assign(document.body.style, {
        marginTop: this.marginTop,
        height: this.height,
        overflow: this.overflow
      })
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop
      document.body.classList.remove('isPrevent')
      this.isPrevent = false
    },
    openPopup() {
      this.preventPageScroll()
      this.showAddressPopup = true
    },
    closePopup() {
      this.restorePageScroll()
      this.isFocus = false
      this.showAddressPopup = false
    },
    phoneFocus() {
      this.$nextTick(() => {
        this.$refs.mobilePhone.focus()
        this.isFocus = true
      })
    },
    async selectConfirm() {
      this.phoneError = false
      this.nameError = false
      this.areaError = false
      this.detailAddressError = false
      if (!this.addressAddInfo.receiverName?.trim()) {
        this.nameError = true
        this.$nextTick(() => {
          this.$refs.receiverName.focus()
        })
        return toast(this.isPickUp ? '请填写姓名！' : '请填写收件人姓名！')
      }

      if (this.addressAddInfo.receiverName.trim().length < 2) {
        this.nameError = true
        this.$nextTick(() => {
          this.$refs.receiverName.focus()
        })
        return toast(this.isPickUp ? '姓名不能少于2个字符' : '收件人姓名少于2个字符')
      }

      if (!this.addressAddInfo.mobilePhone) {
        this.phoneError = true
        this.$nextTick(() => {
          this.$refs.mobilePhone.focus()
        })
        return toast('请输入手机号码！')
      }
      if (!isPhone(this.addressAddInfo.mobilePhone)) {
        this.phoneError = true
        this.$nextTick(() => {
          this.$refs.mobilePhone.focus()
        })
        return toast('请正确填写手机号码！')
      }
      if (!this.area.trim()) {
        this.areaError = true
        this.$nextTick(() => {
          this.$refs.areaContainer.focus()
        })
        return toast('请选择地区！')
      }

      if (!this.addressAddInfo.province.trim()) {
        this.areaError = true
        this.$nextTick(() => {
          this.$refs.areaContainer.focus()
        })
        return toast('请选择地区！')
      }

      if (!this.addressAddInfo.city.trim()) {
        this.areaError = true
        this.$nextTick(() => {
          this.$refs.areaContainer.focus()
        })
        return toast('请选择地区！')
      }

      if (!this.addressAddInfo.area.trim()) {
        this.areaError = true
        this.$nextTick(() => {
          this.$refs.areaContainer.focus()
        })
        return toast('请选择地区！')
      }

      if (!this.addressAddInfo.detailAddress.trim()) {
        this.detailAddressError = true
        this.$nextTick(() => {
          this.$refs.detailAddress.focus()
        })
        return toast('请输入详细地址！')
      }

      if (this.addressAddInfo.detailAddress.trim().length > 50) {
        this.detailAddressError = true
        this.$nextTick(() => {
          this.$refs.detailAddress.focus()
        })
        return toast('详细地址不能超过50个字符')
      }
      const params = {
        id: this.addressAddInfo.id || '',
        receiverName: this.addressAddInfo.receiverName,
        mobilePhone: this.addressAddInfo.mobilePhone,
        province: this.addressAddInfo.province,
        city: this.addressAddInfo.city,
        area: this.addressAddInfo.area,
        detailAddress: this.addressAddInfo.detailAddress,
        isDefault: this.addressAddInfo.isDefault || false
      }
      try {
        if (this.isAddressEdit || this.isFocus) {
          // 更新地址后从获取列表接口，根据id筛选
          let res = await updateAddress(params)
          if (res.code == 0) {
            this.$emit('addressUpdateConfirm')
          } else {
            toast(res.msg)
          }
        } else {
          // 添加地址后从获取列表接口，根据id筛选
          let res = await addAddress(params)
          if (res.code == 0 && res.data) {
            this.$emit('addressAddNewConfirm', res.data)
          } else {
            toast(res.msg)
          }
        }
      } catch (error) {
        toast(error)
      }
    },
    resetAddress() {
      this.$nextTick(() => {
        this.clipboardText = ''
        this.$refs.clipboardAddress.style.height = '36px'
      })
    },
    clipboardIdentify() {
      const cleanText = cleanAddress(this.clipboardText)
      const parseResult = AddressParse.parse(cleanText)
      if (!parseResult || !parseResult[0]) {
        toast('抱歉，没有识别成功哦')
        return
      }
      let { province, city, area, name, mobile: phone, details: detail } = parseResult[0]
      detail = detail.replace(/\s+/gi, ' ')
      // fix 地区/姓名识别异常场景 - 江苏南京市雨花台区南京软件谷 安德门大街25号vivo大厦
      if (detail && name && !phone && name.length > 9 && name.length > detail.length) {
        // 京东-新疆姓名超长的情况
        const checkText = this.clipboardText.replace(new RegExp('(：|:|；|，|,|。|、)', 'g'), ' ')
        if (!checkText.match(new RegExp('(姓名|发件人|收货人|收件人|联系人)(\\s)*' + name, 'ig'))) {
          detail = detail + ' ' + name
          name = ''
        }
      }
      if ((province && city && area) || (name && phone)) {
        toast('识别成功')
        let newAddress = {
          id: '',
          receiverName: name,
          mobilePhone: phone,
          province,
          city,
          area,
          detailAddress: detail
        }
        this.setAddressAddALLInfo(newAddress)
      } else {
        toast('抱歉，没有识别成功哦')
      }
    },
    clipBlur() {
      // 避免识别/清空按钮无法触发
      this.$nextTick(() => {
        this.clipboardBtnShow = false
      })
    },
    clipTouchEnd() {
      // 解决键盘收起 - 弹起过程中遮挡按钮
      setTimeout(() => {
        const targetEl = this.$refs.clipboardActionRef
        if (targetEl) {
          targetEl.scrollIntoView()
        }
      }, 150)
    },
    goLocation() {
      this.$emit('goLocation')
    },
    selectArea() {
      if (this.addressAddInfo.province && this.addressAddInfo.city && this.addressAddInfo.area) {
        this.SET_PICKER_ADDRESS(this.addressAddInfo)
      } else {
        this.SET_PICKER_ADDRESS({})
      }
      this.$emit('selectArea')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/os3_font_include.scss';

.address-add {
  .popup-content {
    overflow: hidden;

    .address-list {
      max-height: calc(90vh - 90px);
      height: 444px;
      position: relative;
      overflow-y: auto;
      padding: 12px 16px 78px;
      box-sizing: border-box;

      .address-list-item {
        position: relative;
        box-sizing: border-box;
        display: flex;
        align-items: center;

        .item-title {
          color: #000;
          width: 60px;
          margin-right: 8px;
        }

        .input-container {
          flex: 1;

          input {
            @include font-weight-two(14, 400);
            display: flex;
            align-items: center;
            padding: 0 0;
            width: 100%;
            border: 1px solid transparent;
            border-radius: 6px;
            box-sizing: border-box;
            background: #f9f9f9;
            color: #000;
            height: 36px;
            box-sizing: border-box;
            padding: 11px 10px;

            .vivo-dark-mode & {
              background-color: #282828;
            }

            &::placeholder {
              color: #aaa;
            }
          }
        }

        &.area-icon {
          input {
            padding: 11px 33px 11px 10px;
          }
        }

        &.isFocus {
          input {
            border: 1px solid #415fff;
            border-radius: 6px;
            box-sizing: border-box;
          }
        }

        &.isError {
          input {
            border: 1px solid rgba(241, 3, 19, 1);
            border-radius: 6px;
            box-sizing: border-box;
          }
        }

        .location-detail {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 11px;
          width: 24px;
          height: 24px;
          background: url('~@/assets/img/repair/confirm/wap/map-icon.svg') center center no-repeat;
          background-size: contain;
        }
      }

      .address-list-copy {
        border-radius: 6px;
        background: #f9f9f9;
        padding: 12px 10px;

        .vivo-dark-mode & {
          background-color: #282828;
        }

        textarea {
          @include font-weight-two(14, 400);
          box-sizing: border-box;
          background: #f9f9f9;
          color: #000;
          width: 100%;
          border: 0px;
          padding: 0px;
          min-height: 36px;
          line-height: 18px;

          .vivo-dark-mode & {
            background-color: #282828;
          }

          &::placeholder {
            color: #aaa;
          }
        }

        .clipboard-actions {
          display: flex;
          justify-content: flex-end;

          .clear {
            color: #aaa;
          }

          .identify {
            margin-left: 12px;
            color: #415fff;
          }
        }
      }

      .item-space {
        margin-top: 14px;
      }

      .item-space-new {
        margin-top: 24px;
      }
    }

    .checkbox {
      margin-top: 33px;
      color: #000;

      .unchecked-box {
        display: flex;
        align-items: center;

        &::before {
          content: '';
          background: url('~@/assets/img/repair/confirm/wap/unselect-icon.svg') center center
            no-repeat;
          background-size: contain;
          width: 18px;
          height: 18px;
          margin-right: 7px;
        }
      }

      .checked-box {
        display: flex;
        align-items: center;

        &::before {
          content: '';
          background: url('~@/assets/img/repair/confirm/wap/select-icon.svg') center center
            no-repeat;
          background-size: contain;
          width: 18px;
          height: 18px;
          margin-right: 7px;
        }
      }
    }
  }

  .popup-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #fff;

    .vivo-dark-mode & {
      background-color: #f7f7f7;
    }
  }
}
</style>
